const inspirationalPrompts = [
  "What are three things you're grateful for today?",
  "Describe a challenge you've overcome recently and what you learned from it.",
  "If you could give advice to your younger self, what would it be?",
  "What's a goal you're working towards, and why is it important to you?",
  "Reflect on a moment that made you proud of yourself recently.",
  "Describe your ideal day. What would you do, and how would it make you feel?",
  "What's a skill you'd like to develop, and how might it enrich your life?",
  "Write about a person who inspires you and why.",
  "What's a positive change you'd like to make in your life, and what steps can you take to achieve it?",
  "Reflect on a time when you helped someone else. How did it make you feel?",
  "What does success mean to you personally?",
  "Describe a place where you feel most at peace. What makes it special?",
  "What's a fear you'd like to overcome, and how might your life change if you did?",
  "Write about a book, movie, or song that has positively impacted your life.",
  "What are some self-care activities that help you feel refreshed and why?"
];

export const getPromptById = (id) => {
  // Ensure the id is within the range of available prompts
  const index = (id - 1) % inspirationalPrompts.length;
  return { id, text: inspirationalPrompts[index] };
};

export const getRandomPrompt = () => {
  const id = Math.floor(Math.random() * inspirationalPrompts.length) + 1;
  return getPromptById(id);
};